
import { useState, useEffect } from 'react';

const priceData = [
  {
    id: 1,
    name: 'Phế Liệu Sắt',
    nameEn: 'Scrap Iron',
    min: '7.000',
    max: '13.000',
    unit: 'đ/kg',
    icon: 'ri-tools-line',
    color: 'from-slate-500 to-slate-700',
    bgLight: 'bg-slate-50',
    borderColor: 'border-slate-200',
    textColor: 'text-slate-700',
    badgeColor: 'bg-slate-100 text-slate-600',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/60cd16fe2240155b7d0fb3d567b13956.jpeg',
    trend: '+2%',
    trendUp: true,
  },
  {
    id: 2,
    name: 'Phế Liệu Đồng',
    nameEn: 'Scrap Copper',
    min: '290.000',
    max: '400.000',
    unit: 'đ/kg',
    icon: 'ri-copper-coin-line',
    color: 'from-amber-500 to-orange-600',
    bgLight: 'bg-amber-50',
    borderColor: 'border-amber-200',
    textColor: 'text-amber-700',
    badgeColor: 'bg-amber-100 text-amber-700',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/b0ddc987eaf2cce0360aac6e9b8bcdfa.jpeg',
    trend: '+5%',
    trendUp: true,
  },
  {
    id: 3,
    name: 'Phế Liệu Nhôm',
    nameEn: 'Scrap Aluminum',
    min: '56.000',
    max: '75.000',
    unit: 'đ/kg',
    icon: 'ri-stack-line',
    color: 'from-sky-400 to-cyan-600',
    bgLight: 'bg-sky-50',
    borderColor: 'border-sky-200',
    textColor: 'text-sky-700',
    badgeColor: 'bg-sky-100 text-sky-700',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/18ecc9c82da7bfbc6b6ca9fc42646a5c.jpeg',
    trend: '+1%',
    trendUp: true,
  },
  {
    id: 4,
    name: 'Phế Liệu Inox',
    nameEn: 'Scrap Stainless Steel',
    min: '11.000',
    max: '32.000',
    unit: 'đ/kg',
    icon: 'ri-shield-line',
    color: 'from-teal-500 to-emerald-600',
    bgLight: 'bg-teal-50',
    borderColor: 'border-teal-200',
    textColor: 'text-teal-700',
    badgeColor: 'bg-teal-100 text-teal-700',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/b460c024de968e188bc705846231b79a.jpeg',
    trend: '0%',
    trendUp: false,
  },
  {
    id: 5,
    name: 'Phế Liệu Hợp Kim',
    nameEn: 'Scrap Alloy',
    min: '1.800.000',
    max: '3.000.000',
    unit: 'đ/kg',
    icon: 'ri-medal-line',
    color: 'from-yellow-500 to-amber-600',
    bgLight: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    textColor: 'text-yellow-700',
    badgeColor: 'bg-yellow-100 text-yellow-700',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/bf763e2eb1e107b02612c32f9c55a17c.jpeg',
    trend: '+8%',
    trendUp: true,
  },
  {
    id: 6,
    name: 'Thu Mua Phế Liệu Máy Móc Cũ',
    nameEn: 'Scrap Base Metal',
    min: '7.000',
    max: '10.000',
    unit: 'đ/kg',
    icon: 'ri-recycle-line',
    color: 'from-green-500 to-teal-600',
    bgLight: 'bg-green-50',
    borderColor: 'border-green-200',
    textColor: 'text-green-700',
    badgeColor: 'bg-green-100 text-green-700',
    image: 'https://static.readdy.ai/image/d95803bb15151fb36255b47b892f2356/84a192642af75f8ce8c30020abdf9813.jpeg',
    trend: '-1%',
    trendUp: false,
  },
];

export default function PriceReport() {
  const [today, setToday] = useState('');
  const [activeCard, setActiveCard] = useState<number | null>(null);

  useEffect(() => {
    const now = new Date();
    const formatted = now.toLocaleDateString('vi-VN', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
    setToday(formatted);
  }, []);

  return (
    <section id="bang-gia" className="py-24 bg-gradient-to-br from-gray-50 via-white to-teal-50/30">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="inline-block bg-teal-100 text-teal-700 text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-4">
            Cập Nhật Hôm Nay
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 leading-tight">
            Bảng Giá Thu Mua
            <span className="text-teal-600"> Phế Liệu</span>
          </h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto mb-3">
            Giá thu mua được cập nhật liên tục theo thị trường. Liên hệ ngay để nhận báo giá chính xác nhất.
          </p>
          <div className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-full px-5 py-2 shadow-sm">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-calendar-line text-teal-600 text-sm"></i>
            </div>
            <span className="text-sm text-gray-600 font-medium">{today}</span>
            <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
            <span className="text-xs text-green-600 font-semibold">Đang cập nhật</span>
          </div>
        </div>

        {/* Price Cards Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-6 mb-12">
          {priceData.map((item) => (
            <div
              key={item.id}
              className={`group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 border ${item.borderColor} cursor-pointer ${activeCard === item.id ? 'ring-2 ring-teal-400 scale-[1.02]' : 'hover:scale-[1.01]'}`}
              onClick={() => setActiveCard(activeCard === item.id ? null : item.id)}
            >
              {/* Image */}
              <div className="relative w-full h-28 sm:h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                {/* Badge on image */}
                <div className={`absolute top-2 left-2 ${item.badgeColor} text-xs font-bold px-2 py-0.5 rounded-full backdrop-blur-sm hidden sm:block`}>
                  {item.nameEn}
                </div>
                {/* Trend badge */}
                <div className={`absolute top-2 right-2 flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-xs font-bold ${item.trendUp ? 'bg-green-500 text-white' : item.trend === '0%' ? 'bg-gray-400 text-white' : 'bg-red-500 text-white'}`}>
                  <div className="w-3 h-3 flex items-center justify-center">
                    <i className={`${item.trendUp ? 'ri-arrow-up-line' : item.trend === '0%' ? 'ri-subtract-line' : 'ri-arrow-down-line'} text-xs`}></i>
                  </div>
                  {item.trend}
                </div>
              </div>

              {/* Content */}
              <div className={`p-3 sm:p-5 ${item.bgLight}`}>
                <div className="flex items-center gap-2 sm:gap-3 mb-2 sm:mb-4">
                  <div className={`w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-xl bg-gradient-to-br ${item.color} shadow-md shrink-0`}>
                    <i className={`${item.icon} text-white text-sm sm:text-lg`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-bold text-gray-900 text-xs sm:text-base leading-tight line-clamp-2">{item.name}</h3>
                    <span className="text-xs text-gray-400">{item.unit}</span>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
                  <div>
                    <p className="text-xs text-gray-500 mb-0.5 font-medium uppercase tracking-wide hidden sm:block">Giá thu mua</p>
                    <div className={`text-sm sm:text-xl font-extrabold ${item.textColor} leading-none`}>
                      {item.min}–{item.max}
                    </div>
                    <p className="text-xs text-gray-400 mt-0.5">{item.unit}</p>
                  </div>
                  <a
                    href="tel:0968947136"
                    onClick={(e) => e.stopPropagation()}
                    className="flex items-center justify-center gap-1 bg-gray-900 hover:bg-teal-600 text-white text-xs font-bold px-3 py-1.5 sm:px-4 sm:py-2 rounded-full transition-all whitespace-nowrap"
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-phone-line text-xs"></i>
                    </div>
                    <span className="hidden sm:inline">Báo giá</span>
                    <span className="sm:hidden">Gọi</span>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note + CTA */}
        <div className="bg-white border border-gray-100 rounded-2xl shadow-sm p-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-xl shrink-0">
              <i className="ri-information-line text-amber-600 text-xl"></i>
            </div>
            <div>
              <p className="font-semibold text-gray-800 text-sm mb-1">Lưu ý về bảng giá</p>
              <p className="text-gray-500 text-xs leading-relaxed">
                Giá trên là giá tham khảo, có thể thay đổi theo chất lượng, số lượng và thời điểm thu mua. Liên hệ trực tiếp để nhận báo giá chính xác và ưu đãi tốt nhất.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <a
              href="tel:0968947136"
              className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-bold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap shadow-md"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-sm"></i>
              </div>
              Gọi: 0968 947 136
            </a>
            <a
              href="https://zalo.me/0968947136"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-amber-400 hover:bg-amber-500 text-gray-900 font-bold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap shadow-md"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-message-2-line text-sm"></i>
              </div>
              Chat Zalo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
